<template>
  <el-dialog v-model="open" title="名片选择" width="800">
    <template #header="{ titleId, titleClass }">
      <div class="my-header">
        <h4 :id="titleId" :class="titleClass">名片选择</h4>
        <el-button
          size="small"
          type="primary"
          @click.stop="handleRefreshSysCfgInfo"
          style="margin-left: auto">
          <el-icon>
            <RefreshRight />
          </el-icon>
          刷新
        </el-button>
        <!-- <el-icon style="margin-left: auto;cursor: pointer;" @click="close"><CircleClose /></el-icon> -->
      </div>
    </template>
    <el-scrollbar height="600px">
      <div>
        <div class="flex_center">
          <el-segmented
            v-model="selectedCardBigTypeRef"
            :options="cardBigTypeList"
            block
            @change="handleBigTypeChange">
            <template #default="{ item }">
              <div class="flex flex-col items-center gap-2 p-2">
                {{ item.label }}
              </div>
            </template>
          </el-segmented>
        </div>

        <!-- <div v-for="item in currentCardList" :key="item.type_id">
                {{ item }}
            </div> -->
        <el-collapse v-model="activeTypeId" accordion v-if="currentCardList?.length > 0">
          <el-collapse-item
            :title="item.type_name"
            :name="item.type_id"
            v-for="item in currentCardList"
            :key="item.type_id">
            <template #title>
              <div class="el-collapse_t1 title_l">
                <!-- <i class="iconfont icon-fenzu m_color_2"></i> -->
                {{ item.type_name }}
              </div>
            </template>
            <div>
              <div v-for="sub_item in item.list" :key="sub_item.id" class="m_card_item">
                <div class="flex_center">
                  <div style="width: 50%">
                    <cardItem :cardItem="sub_item"></cardItem>
                  </div>
                  <div class="send_container">
                    <el-tooltip class="box-item" effect="light" placement="top-start">
                      <template #content>点击发送名片</template>
                      <img
                        @click="handleSendCard(sub_item)"
                        src="@assets/img/send.png"
                        style="width: 30px; height: 30px; cursor: pointer" />
                    </el-tooltip>
                  </div>
                </div>
              </div>
            </div>
          </el-collapse-item>
        </el-collapse>
        <el-empty v-else description="没有数据"></el-empty>
      </div>
    </el-scrollbar>

    <!-- {{ cardList }} -->
  </el-dialog>
</template>

<script>
import {
  onMounted,
  ref,
  reactive,
  toRefs,
  watch,
  nextTick,
  inject,
  computed,
  onUnmounted,
} from "vue";
import { useStore } from "vuex";
import cardItem from "./carditem.vue";
import { RefreshRight } from "@element-plus/icons-vue";
import { initUserSystemData } from "@/api/userapi";
import { ElMessage } from "element-plus";
import { unescape } from "lodash";
export default {
  components: { cardItem, RefreshRight },
  emits: ["sendCard"],
  props: { _item: { type: String, default: "" } },
  setup(props, { emit }) {
    // ---------- 属性 --------------------
    let store = useStore();
    const open = ref(false);
    const activeTypeId = ref(undefined);
    const cardList = computed(() => {
      return store.state.chat_store.user_config?.card_list || {};
    });

    const currentCardList = computed(() => {
      if (!store.state.chat_store.user_config?.card_list) {
        return [];
      }

      let allCardList = store.state.chat_store.user_config?.card_list;
      if (!allCardList) {
        return "";
      }
      let bigTypeCardList = allCardList[selectedCardBigTypeRef.value];
      //根据所选平台过滤出可显示的名片类型
      if (!bigTypeCardList) {
        return [];
      }

      let showList = [];
      let _showCardSubType = showCardSubType.value;
      for (let item of bigTypeCardList) {
        let item0 = { ...item };
        let _list = item.list;
        _list = _list.filter((_item) => _item.sub_type == _showCardSubType);
        if (_list?.length > 0) {
          item0.list = _list;
          showList.push(item0);
        }
      }
      return showList || [];
    });

    //卡片大分类
    const cardBigTypeList = ref([
      { label: "公共名片", value: "card_type1" },
      // {label:'部门快捷语',value:'fast_reply_type2'},
      { label: "个人名片", value: "card_type3" },
    ]);

    const showCardSubType = computed(() => {
      let plat_id = store.state.chat_store.chat_plat_id;
      //网站
      if (plat_id == 3) {
        return 1;
      } else if (plat_id == 4) {
        //微信客服
        return 2;
      }
      return undefined;
    });
    //当前选中平台
    const chatingPlatId = computed(() => {
      return store.state.chat_store.chat_plat_id;
    });
    //选中的大分类
    const selectedCardBigTypeRef = ref("card_type1");

    /*{
            "id": "1",
                "name": "H5页面名片"
            },
            {
                "id": "2",
                "name": "微信客服名片"
            }*/
    // ---------- 方法 --------------------
    const handleBigTypeChange = (changeV) => {
      let bigList = store.state.chat_store.user_config?.card_list;
      if (!bigList) {
        return undefined;
      }
      let list = bigList[changeV];
      if (list && list.length > 0) {
        activeTypeId.value = list[0].type_id;
      }
    };
    const show = () => {
      handleBigTypeChange("card_type1");
      open.value = true;
    };

    //刷新系统配置信息
    const handleRefreshSysCfgInfo = () => {
      initUserSystemData().then(() => {
        ElMessage({
          message: "刷新成功",
          type: "success",
          plain: true,
        });
      });
    };

    const handleSendCard = async (cardItem) => {
      emit("sendCard", cardItem);
      open.value = false;
    };

    // ---------- 生命周期 --------------------
    return {
      open,
      store,
      cardList,
      cardBigTypeList,
      currentCardList,
      selectedCardBigTypeRef,
      activeTypeId,
      chatingPlatId,
      // ----- 图标 -------
      // --------- 方法 ------
      show,
      handleRefreshSysCfgInfo,
      handleSendCard,
      handleBigTypeChange,
    };
  },
};
</script>

<style lang="scss" scoped>
.my-header {
  display: flex;
  align-items: center;
}

.m_card_item {
  padding-top: 10px;
  padding-bottom: 5px;
}

.m_card_item:not(:first-child) {
  border-top: 1px dashed #d9d9d9;
}

.send_container {
  align-self: flex-start;
  position: relative;
  transform: translateY(25%);
  cursor: pointer;
}
</style>
